var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-list',{attrs:{"light":""}},[_vm._l((_vm.entries),function(entry,i){return [_c('v-list-tile',{key:i,attrs:{"to":entry.to}},[_vm._v("\n        "+_vm._s(entry.title)+"\n      ")])]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }